import { SendEventProps } from '../../interface/biEvents';

export const mpSellerNameClicked = () =>
    ({
        eventName: 'Gig page - Seller card - Seller name clicked',
    } satisfies SendEventProps);
